import { queryArgs } from '@/utils';
import routes from './routes';

// Helper to get a route for a given slug
function getRouteForSlug(slug) {
	slug = slug.replace('optin-monster-', '');

	if (slug) {
		return routes.find((r) => {
			if (r.meta.slug.includes('=:')) {
				return slug === (r.name || r.meta.slug);
			}

			return slug === (r.meta.slug || r.name);
		});
	}

	return false;
}

// Helper to get a route for a given url
function getRouteForUrl(url) {
	const pattern = /[?&]page=(optin-monster-[^&#\t\n\r]+)+/;
	const matches = url.match(new RegExp(pattern));

	return matches && matches[1] && getRouteForSlug(matches[1]);
}

function getRoutePathFromArgs({ route, args }) {
	const pathArgs = queryArgs.parse(route.path);
	let params = {};

	Object.keys(pathArgs).forEach((pathArg) => {
		if (args[pathArg]) {
			params[pathArg] = args[pathArg];
		}
	});

	return { name: route.name, params };
}

function getRouteForArgs(args) {
	const slug = args.page.replace('optin-monster-', '');
	delete args.page;

	const findMatches = (r) => {
		const name = r.meta.slug || r.name || '';

		return name.match(slug);
	};

	const addPriority = (route) => {
		const keys = Object.keys(args).filter((arg) => route.path.match(arg));

		let matchedArgs = {};
		keys.forEach((k) => {
			matchedArgs[k] = args[k];
		});

		return {
			args: matchedArgs,
			priority: keys.length,
			route,
		};
	};

	const sortByPriority = (a, b) => b.priority - a.priority;

	const matchingRoute = routes.filter(findMatches).map(addPriority).sort(sortByPriority).shift();

	if (matchingRoute) {
		return getRoutePathFromArgs(matchingRoute);
	}

	return false;
}

// Helper to get a route for a given query string.
function getRouteForQuery(queryString = null) {
	const args = queryArgs.parse(queryString);
	const { page } = args;

	if (!page || !page.match('optin-monster-')) {
		return false;
	}

	if (1 < Object.keys(args).length) {
		const route = getRouteForArgs(args);
		if (route) {
			return route;
		}
	}

	return getRouteForSlug(page);
}

function getPreviousRoute() {
	return this._prevRoute;
}

function goPrevious() {
	const prev = this.getPreviousRoute();
	this.push(prev.name ? prev : { name: 'dashboard' });
}

export default {
	getRouteForSlug,
	getRouteForUrl,
	getRouteForQuery,
	getPreviousRoute,
	goPrevious,
};
